import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  .disabled {
    pointer-events: none;
    opacity: 0.4;
  }
`
